import { ContractTableDTO } from '../../../../Domain/DTO/ContractTableDTO';


export class ContractHelperProps{
    
    Contracts: Array<ContractTableDTO>
    ContractsOriginal: Array<ContractTableDTO>
}

export const InitialContractHelperProps: ContractHelperProps = <ContractHelperProps>{ Contracts: [], ContractsOriginal: []};